import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getCustomers({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate
        const query = payload.query

        commit('GET_CUSTOMERS_REQUEST')

        return axios
            .get(`/customers/customers${paginate}${query}`)
            .then(response => {
                commit('GET_CUSTOMERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_CUSTOMERS_FAILURE')
                handleApiError(error, 'Pobranie listy klientów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCustomer(context, customerId) {
        return axios
            .get(`/customers/customers/${customerId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych dla klienta ${customerId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createCustomer({ commit }, customerData) {
        return axios
            .post('/customers/customers', customerData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Klient został dodany.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie klienta nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCustomer({ commit }, customerData) {
        return axios
            .put(`/customers/customers/${customerData.id}`, customerData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Klient został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis klienta nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteCustomer({ commit }, customerId) {
        return axios
            .delete(`/customers/customers/${customerId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Klient został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie klienta nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCustomerAddresses(context, customerId) {
        return axios
            .get(`/customers/customer-addresses?customer_id=${customerId}&addressType_id=2`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie adresów klienta nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCustomerTypes({ commit }) {
        return axios
            .get('/customers/customers/dicts/types')
            .then(response => {
                commit('GET_CUSTOMERS_TYPES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów klientów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAddressTypes({ commit }) {
        return axios
            .get('/customers/customers/dicts/address-types')
            .then(response => {
                commit('GET_ADDRESS_TYPES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów adresów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCountries({ commit }) {
        return axios
            .get('/geolocalizations/geolocalizations/dicts/countries')
            .then(response => {
                commit('GET_COUNTRIES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie krajów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionFileCustomerConfiguration({ commit }) {
        return axios
            .get('/files/dicts/production-file-customer-configuration')
            .then(response => {
                commit('GET_PRODUCTION_FILE_CUSTOMER_CONFIGURATION_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie flow nie powiodło się.')

                return Promise.reject(error)
            })

    },
    setCustomersFilters({ commit }, filters) {
        commit('SET_CUSTOMERS_FILTERS', filters)
    },
    clearCustomersFilters({ commit }) {
        commit('CLEAR_CUSTOMERS_FILTERS')
    }
}